import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MoneyActionSelectComponent } from 'src/app/pages/money/money-and-transactions/money-and-transactions.component';
import { MoneyDepositEditComponent } from 'src/app/pages/money/money-deposit-edit/money-deposit-edit.component';
import { MoneyDepositListComponent } from 'src/app/pages/money/money-deposit-list/money-deposit-list.component';
import { MoneyRentComponent } from 'src/app/pages/money/money-rent/money-rent.component';
import { MoneyWithdrawComponent } from 'src/app/pages/money/money-withdraw/money-withdraw.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: MoneyActionSelectComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: 'deposit',
    component: MoneyDepositListComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: 'investment/:id',
    component: MoneyDepositEditComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: 'withdraw',
    component: MoneyWithdrawComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: 'rent',
    component: MoneyRentComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: ':initialInvestmentId',
    component: MoneyActionSelectComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MoneyRoutingModule { }
